import Vue from 'vue'
import App from './App.vue'
import { store } from './store/';
import { router } from './routes.js';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { i18n } from './model/i18n.js';
import { formatter } from './model/formatter.js';
import jQuery from "jquery";
import SvgSprite from 'vue-svg-sprite';

const $ = jQuery;
window.$ = $;

Vue.use(SvgSprite, {
	url: require('./assets/svg/sprite.svg')
});
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use({
    install: function(Vue, options){
        Vue.prototype.$jQuery = require('jquery'); // you'll have this.$jQuery anywhere in your vue project
    }
});

// my Vue extension
Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
		return i18n.locale;
    },
    set: function (locale) {
		i18n.locale = locale;
    }
});
Vue.prototype.$moneyf = (num, precMin, precMax) => {
	return formatter.formatNumber(num, 'money', precMin, precMax);
};
Vue.prototype.$pricef = (num, precMin, precMax) => {
	return formatter.formatNumber(num, 'price', precMin, precMax);
};
Vue.prototype.$datef = (date, fmtStr) => {
	return formatter.formatDateTime(date, fmtStr);
};


let vue = new Vue({
	el: '#app',
	store: store,
	router: router,
	i18n: i18n,
	render: h => h(App)
});
